export default __webpack_public_path__ + "static/media/logo_mini.4dc2ab21.png";